<script>
export default {
    name: "DiagnosisTab",

    data() {

        return {
            diagnosis: [],
        };
    },

    props: {
        patient: {
            type: Object,
            required: true,
        },
    },

    mounted() {

        this.$root.loading = true;
        Promise.all([ this.fetchDiagnosis(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchDiagnosis() {
            let url = `MedicalFile/GetPatientDiagnosis`;
            url += `?PatientID=${this.patient.patienT_ID}`;
            url += `&VisitNo=${this.patient.visitNo}`;

            return this.$http
              .get(url)
              .then(({ data }) => {
                this.diagnosis = data;
              })
              .catch(() => {});
        },
    },
}
</script>
<template>
<div class="w-full overflow-auto">
    <table class="table">
        <thead class="bg-blue-500 text-sm text-white">
          <tr class="flex w-full">
            <th class="p-tiny flex-1">Date</th>
            <th class="p-tiny flex-1">Disease</th>
            <th class="p-tiny flex-1">Stage</th>
            <th class="p-tiny flex-1">Comment</th>
            <th class="p-tiny flex-1">Username</th>
          </tr>
        </thead>
        <tbody
          class="text-sm bg-gray-100 flex flex-col items-center overflow-auto"
          style="max-height:50vh;"
        >
          <tr class="w-full flex" v-for="(diag, idx) in diagnosis" :key="idx">
            <td class="p-tiny flex-1">{{ diag.sysDate | dateFormatDT }}</td>
            <td class="p-tiny flex-1">{{ diag.disease }}</td>
            <td class="p-tiny flex-1">{{ diag.stage }}</td>
            <td class="p-tiny flex-1 break-words">{{ diag.comment || `-` }}</td>
            <td class="p-tiny flex-1">{{ diag.userName }}</td>
          </tr>
        </tbody>
    </table>
</div>
</template>
